

export const convertCelsiusToFahrenheit = (temperature: number) => {
  return ((temperature * 9) / 5 + 32).toFixed(1)
}

export const convertFahrenheitToCelsius = (fahrenheit: number) =>
  (((fahrenheit - 32) * 5) / 9).toFixed(1);

export const isObject = (value: any): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
};

export const isInStandaloneMode = () =>
  (window.navigator as any).standalone || window.matchMedia('(display-mode: standalone)').matches;


export const displayFloorAndDoorByName = (name: string | null, returnString: boolean = false) => {
  let floor = null;
  let door = null;
  if (name) {
    const parts = name.split('-');
    //if (parts.length < 4) return { floor: null, door: null }; 
    let numberPart = parts[3];
    if (parts[0] === "SBM") {
      numberPart = parts[2];
    }
    if (numberPart) {
      door = numberPart;
    }
    //Vigh
    const parts2 = name.split('_');
    if (parts2.length > 1) {
      door = parts2[3] || parts2[2]
    }
    //Karikas
    if (parts[0] === "BPKAR15") {
      door = parts[1];
    } else if (parts[1] === "KAR15") {
      door = parts[2];
    }
  /*
    if (numberPart.length === 3) {
      door = numberPart;
    } else if (numberPart.length === 4) {
      floor = numberPart.slice(0, 2);
      door = numberPart.slice(2, 4)
    } */
  }

  if (returnString) {
    return door;
  }
  return (
    <span>
      {floor && <span>{floor},</span>}
      {door && <span>{door}</span>}
    </span>
  )
};

const collator = new Intl.Collator('hu', { numeric: false, sensitivity: 'base' });

function extractLastBlock(name: string): { letter: string, number: number, original: string } {
  // Megkeresi az utolsó kötőjel utáni karakterláncot
  // Pl. "CÜ01", "DÜ02", "002", "011"
  const blocks = name.split("-");
  const block = blocks[blocks.length - 2] ?? ""; // általában az utolsó előtti tag a lakásszám

  // Szétszedi betűkre/számokra
  const match = block.match(/^([A-Za-zÁÉÍÓÖŐÚÜŰáéíóöőúüű]*)(\d+)$/);
  if (match) {
    return {
      letter: match[1] || "",
      number: Number(match[2]),
      original: block,
    };
  }
  // Ha mégsem felel meg a mintának (pl. csak szám, vagy valami fura), fallback
  return {
    letter: "",
    number: isNaN(Number(block)) ? -1 : Number(block),
    original: block,
  };
}

export function sortByApartmentName(apartments: any) {
  return apartments.sort((a: any, b: any) => {
    const aBlock = extractLastBlock(a.name);
    const bBlock = extractLastBlock(b.name);

    // Először betű szerint magyarul (üres string kisebb minden betűsnél)
    const letterCompare = collator.compare(aBlock.letter, bBlock.letter);
    if (letterCompare !== 0) return letterCompare;

    // Aztán szám szerint
    if (aBlock.number !== bBlock.number) {
      return aBlock.number - bBlock.number;
    }

    // Ha minden egyezik, a teljes névvel döntsünk (pl. ha "lakáskör" is változik)
    return collator.compare(a.name, b.name);
  });
}

export const hashPassword = async (password: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};